// extracted by mini-css-extract-plugin
export default {"headerBar":"jJ-z","pointsSection":"kJ-z","goToDashboard":"lJ-z"};